{
  "font": "Raleway, Inter, sans-serif",
  "background": "transparent",
  "view": { "stroke": null },
  "padding": 5,
  "axis": {
    "labelColor": "#64748b",
    "titleColor": "#64748b",
    "labelFontSize": 11,
    "titleFontSize": 11,
    "titleFontWeight": 500,
    "domainColor": "#e2e8f0",
    "tickColor": "#e2e8f0",
    "gridColor": "#e2e8f0"
  },
  "title": {
    "color": "#0f172a",
    "fontSize": 13,
    "fontWeight": 600,
    "anchor": "start",
    "offset": 12
  },
  "legend": {
    "labelColor": "#0f172a",
    "titleColor": "#64748b",
    "labelFontSize": 11,
    "titleFontSize": 11,
    "symbolType": "circle"
  }
}
